<script setup lang="ts">
import { useScrollLock } from '@/composables/useScrollLock';
import { useKeycloak } from '@dsb-norge/vue-keycloak-js';
import { watchEffect } from 'vue';

const open = defineModel<boolean>();
const { lockScroll, unlockScroll } = useScrollLock();

const logout = () => {
  const keycloak = useKeycloak();
  const logoutUrl = keycloak.createLogoutUrl!();
  window.location.href = logoutUrl;
};

watchEffect(() => {
  if (open.value) {
    lockScroll();
  } else {
    unlockScroll();
  }
});
</script>

<template>
  <div v-if="open" class="fixed inset-0 flex items-center justify-center bg-lumar-blue z-50">
    <div class="absolute top-[54px] right-4">
      <Button
        @click="open = false"
        class="text-white!"
        icon="pi pi-times"
        size="large"
        variant="text"
        rounded
        aria-label="close"
      />
    </div>
    <div class="flex flex-col w-full gap-8 px-8">
      <router-link to="/" class="text-white text-2xl font-semibold" @click="open = false">
        Domov
      </router-link>
      <router-link
        to="/lumar-activities"
        class="text-white text-2xl font-semibold"
        @click="open = false"
      >
        Lumar aktivnosti
      </router-link>
      <router-link
        to="/color-palette"
        class="text-white text-2xl font-semibold"
        @click="open = false"
      >
        Barvna paleta hiše
      </router-link>
      <router-link
        to="/recommendations"
        class="text-white text-2xl font-semibold"
        @click="open = false"
      >
        Priporočajte nas
      </router-link>
      <hr class="h-0.5 border-white/20" />
      <div class="flex justify-between align-baseline">
        <span class="text-white text-2xl font-semibold" @click="logout()"> Odjava </span>
      </div>
    </div>
  </div>
</template>
